<template>
  <BaseVeeForm
    :action="trySubmit"
    v-slot="{ isPending, invalid }"
    class="space-y-6"
    @success="$emit('success')"
    @failure="$emit('failure')"
  >
    <ValidationProvider rules="required" name="content" slim vid="content">
      <template #default="{ errors }">
        <BaseFormGroup>
          <BaseFormLabel for="content"> Description </BaseFormLabel>
          <BaseFormTextarea
            id="content"
            rows="10"
            v-model="formData.content"
            :disabled="isPending"
          />
          <BaseFormInlineMessage v-if="errors.length" danger>
            {{ errors[0] }}
          </BaseFormInlineMessage>
        </BaseFormGroup>
      </template>
    </ValidationProvider>

    <ValidationProvider name="tags" slim vid="tags">
      <template #default="{ errors }">
        <BaseFormGroup>
          <BaseFormLabel for="tags"> Tags </BaseFormLabel>
          <ul class="flex flex-wrap">
            <template v-for="tag in tags">
              <li :key="tag.id" class="p-1">
                <label
                  class="inline-flex p-1 border border-transparent text-sm rounded-full focus-within:ring ring-blue-500 ring-opacity-50 focus-within:border-blue-700"
                  :class="[
                    formData.tags.indexOf(tag.id) > -1 ? 'bg-blue-600 text-white' : 'bg-gray-200',
                  ]"
                >
                  <input
                    v-model="formData.tags"
                    type="checkbox"
                    :value="tag.id"
                    class="appearance-none opacity-0"
                  />
                  <div class="flex items-center px-2 space-x-2">
                    <span class="inline-flex leading-4">
                      {{ tag.name }}
                    </span>
                  </div>
                </label>
              </li>
            </template>
          </ul>
          <BaseFormInlineMessage v-if="errors.length" danger>
            {{ errors[0] }}
          </BaseFormInlineMessage>
        </BaseFormGroup>
      </template>
    </ValidationProvider>

    <div class="flex space-x-2">
      <BaseButton primary :disabled="isPending || invalid">
        {{ label }}
      </BaseButton>
    </div>
  </BaseVeeForm>
</template>

<script>
export default {
  name: 'NoteForm',
  props: {
    tags: {
      type: Array,
      default: () => [],
    },
    defaultData: {
      type: Object,
      default: () => ({}),
    },
    label: {
      type: String,
      default: 'Submit',
    },
    action: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      formData: {
        content: this.defaultData?.content || '',
        tags: [...(this.defaultData?.tags || [])],
      },
    };
  },
  computed: {
    selectedTags: {
      get() {
        return this.formData.tags
          .map((tagId) => this.tags.find((tag) => tag.id === tagId))
          .filter((tag) => tag);
      },
      set(tags) {
        this.formData.tags = tags.map((tag) => tag.id);
      },
    },
  },
  methods: {
    limitText(count) {
      return `and ${count} more tags`;
    },
    async trySubmit() {
      try {
        await this.action(this.formData);
        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      }
    },
  },
};
</script>
